import { useTranslation } from "react-i18next";
import { AddNewEquipment } from "./AddNewEquipment";

interface IParams {
    onClick(): void;
    isLoading?: boolean;
}

export const AddWifiBoost = (props: IParams) => {
    const { onClick, isLoading = false } = props;
    const { t } = useTranslation("cart");

    return (
        <AddNewEquipment
            isLoading={isLoading}
            title={t("broadband.cartBroadbandAddon.addWifiBoost")}
            onClick={onClick}
        />
    );
};
